module.exports = __webpack_public_path__ + "img/B.762347cd.jpg";